import { render } from "./ReplyBadge.vue?vue&type=template&id=5d04ebe8&ts=true"
import script from "./ReplyBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyBadge.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyBadge.vue?vue&type=style&index=0&id=5d04ebe8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d04ebe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d04ebe8', __exports__)) {
    api.reload('5d04ebe8', __exports__)
  }
  
  module.hot.accept("./ReplyBadge.vue?vue&type=template&id=5d04ebe8&ts=true", () => {
    api.rerender('5d04ebe8', render)
  })

}


export default __exports__